import { LoadingSkeleton } from 'sonata-react-components';

type Props = {
  height?: number;
  titleWidth?: number;
};

export function SelectorSkeleton({ height = 66.74, titleWidth = 45 }: Props) {
  return (
    <div className="selectorSkeleton" style={{ height: `${height}px` }}>
      <LoadingSkeleton count={1} height={15} width={titleWidth} />
      <LoadingSkeleton count={1} height={39} style={{ marginTop: '7px' }} />
    </div>
  );
}
